import { render, staticRenderFns } from "./diabond-account-card.vue?vue&type=template&id=28c506ab&scoped=true&"
import script from "./diabond-account-card.vue?vue&type=script&lang=js&"
export * from "./diabond-account-card.vue?vue&type=script&lang=js&"
import style0 from "./diabond-account-card.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./diabond-account-card.vue?vue&type=style&index=1&id=28c506ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c506ab",
  null
  
)

export default component.exports